import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatRadioChange, MatRadioModule } from '@angular/material/radio';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { of, Subscription, switchMap } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import moment from 'moment';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf, NgFor } from '@angular/common';

import { pageTransitions } from '../../../../shared/animations/page-transitions';
import { StepStatus, StepperComponent } from '../../../../shared/components/stepper/stepper.component';
import { BocClient } from '../../../../shared/models/boc-client-transac';
import { ErrorService } from '../../../../shared/services/error.service';
import { LocationService } from '../../../../shared/services/location.service';
import { TranslationService } from '../../../../shared/services/translation.service';
import { UserService } from '../../../../shared/services/user.service';
import { User } from '../../../../shared/models/user';
import { Guarantee } from '../../../models/guarantee';
import { GuaranteeRequestService } from '../../../services/guarantee-request.service';
import { SnackbarSaveDraftGuaranteeComponent } from '../../utils/snackbar-save-draft-guarantee.component';
import { GuaranteeStatus } from '../../../models/guarantee-constants';
import { LoadingSpinnerComponent } from '../../../../shared/components/utils/loading-spinner.component';
import { InputNumberDirective } from '../../../../shared/directives/input-number.directive';
import { PageHeaderComponent } from '../../../../shared/components/page-header/page-header.component';
import {
	FeedbackErrorComponent
} from '../../../../shared/components/feedback-error/feedback-error.component';

interface ErrorObject {
	soldTo: boolean;
	name: boolean;
}
type BuildingType = 'industrial' | 'agricultural';

@Component({
	selector: 'copo-project-characteristics-organic',
	templateUrl: './project-characteristics-organic.component.html',
	styleUrl: './project-characteristics-organic.component.css',
	animations: pageTransitions,
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		CdkScrollable,
		PageHeaderComponent,

		MatButtonModule,
		TranslateModule,
		MatIconModule,
		FormsModule,
		StepperComponent,

		MatFormFieldModule,

		MatInputModule,
		ReactiveFormsModule,

		MatSelectModule,
		NgFor,

		MatOptionModule,

		MatCheckboxModule,

		MatRadioModule,
		InputNumberDirective,
		LoadingSpinnerComponent,
		FeedbackErrorComponent,
	]
})
export class ProjectCharacteristicsOrganicComponent implements OnInit, OnDestroy {
	@ViewChild('soldToDiv', { read: ElementRef }) soldToDiv!: ElementRef<HTMLElement>;
	@ViewChild('nameDiv', { read: ElementRef }) nameDiv!: ElementRef<HTMLElement>;

	@Input() guaranteeResponse!: Guarantee;

	submitting = false;
	isLoading = true;
	soldTos: BocClient[] | undefined;
	guarantee!: Guarantee;
	user: User;
	readonly steps;

	onErrorMandatory = {

		soldTo: false,
		name: false,

	};

	humidityRate = {
		low: 'Low',
		medium: 'Medium',
		high: 'High',
		veryHigh: 'Very High',
		saturated: 'Saturated'
	};

	selectedOption = new FormControl('newBuildingCompleteConstruction');
	soldToFormControl!: FormControl<string>;
	projectNameFormControl!: FormControl<string>;
	newBuildingCompleteConstructionFormControl!: FormControl<boolean>;
	reasonFormControl!: FormControl<string>;
	natureMaterialFormControl!: FormControl<string>;
	conditionMaterialFormControl!: FormControl<string>;
	ageMaterialFormControl!: FormControl<string>;
	extensionExistingBuildingFormControl!: FormControl<boolean>;
	retrofittingRepairExistingBuildingFormControl!: FormControl<boolean>;
	residentialUseFormControl!: FormControl<boolean>;
	industrialFormControl!: FormControl<boolean>;
	agriculturalFormControl!: FormControl<boolean>;
	otherADBFormControl!: FormControl<boolean>;
	otherADBSpecifyFormControl!: FormControl<string>;
	buildingsFormControl!: FormControl<BuildingType | null>;
	activityBuildingFormControl!: FormControl<boolean>;
	acitivityInsideBuildingFormControl!: FormControl<string>;
	presenceofChemicalFormControl!: FormControl<string>;
	natureContentFormControl!: FormControl<string>;
	presenceofFermentationFormControl!: FormControl<string>;
	natureContent2FormControl!: FormControl<string>;
	gasVapourFormControl!: FormControl<string>;
	gasvaporNatureContentFormControl!: FormControl<string>;
	buildingHeatedFormControl!: FormControl<string>;
	heatingTypeFormControl!: FormControl<string>;
	qiaExtractorFormControl!: FormControl<boolean>;
	qiaChimneyFormControl!: FormControl<boolean>;
	qiaNaturalventilationFormControl!: FormControl<boolean>;
	qiaForcedventilationFormControl!: FormControl<boolean>;
	otherEquipmentFormControl!: FormControl<boolean>;
	specifyOtherEquipmentFormControl!: FormControl<string>;
	qiacondriskbuildingFormControl!: FormControl<string>;
	activityAgriculturalBuildingFormControl!: FormControl<boolean>;
	storageFodderFormControl!: FormControl<boolean>;
	storageFertilizerFormControl!: FormControl<boolean>;
	breedingAnimalsFormControl!: FormControl<boolean>;
	cattleFormControl!: FormControl<boolean>;
	pigsFormControl!: FormControl<boolean>;
	polutryFormControl!: FormControl<boolean>;
	otherAnimalsFormControl!: FormControl<boolean>;
	animalsInsideBuildingFormControl!: FormControl<string>;
	densityofAnimalsFormControl!: FormControl<string>;
	animalsinShedFormControl!: FormControl<string>;
	manureManagementFormControl!: FormControl<boolean>;
	manureManagementConcreteGratingDuckboardFormControl!: FormControl<boolean>;
	manureManagementNoDuckboardFormControl!: FormControl<boolean>;
	ambienceBuildingFormControl!: FormControl<boolean>;
	naturalVentilationFormControl!: FormControl<boolean>;
	naturalVentilationRoofFormControl!: FormControl<boolean>;
	forcedVentilationFormControl!: FormControl<boolean>;
	otherVentilationFormControl!: FormControl<boolean>;
	otherVentilationSpecifyFormControl!: FormControl<string>;
	airRenewalFormControl!: FormControl<string>;
	ammoniaFormControl!: FormControl<string>;
	hydrogenSulphideFormControl!: FormControl<string>;
	humidityFormControl!: FormControl<string>;
	buildingHumidityRateFormControl!: FormControl<string>;
	private soldToSub!: Subscription;

	constructor(
		private readonly locationService: LocationService,
		private readonly translationService: TranslationService,
		private readonly userService: UserService,

		private readonly snackBar: MatSnackBar,
		private readonly router: Router,
		private readonly guaranteeService: GuaranteeRequestService,

		private readonly errorService: ErrorService,
	) {
		this.steps = [
			{
				label: this.translationService.getTR('guarantee.project.characteristics'),
				status: StepStatus.CURRENT,
			},
			{
				label: this.translationService.getTR('guarantee.project.environment'),
				status: StepStatus.DISABLED,
			},
			{
				label: this.translationService.getTR('guarantee.type'),
				status: StepStatus.DISABLED,
			},
			{
				label: this.translationService.getTR('guarantee.summary'),
				status: StepStatus.DISABLED,
			}
		];
		this.user = this.userService.user;
	}

	ngOnInit() {
		this.errorService.resetErrorMsg();
		this.guarantee = this.guaranteeResponse;
		this.guarantee.newBuildingCompleteConstruction = true;
		this.soldToFormControl = new FormControl(
			this.guarantee.soldTo,
			{ validators: ctrl => this.onErrorMandatory.soldTo ? Validators.required(ctrl) : null, nonNullable: true }
		);
		this.projectNameFormControl = new FormControl(
			this.guarantee.name,
			{ validators: ctrl => this.onErrorMandatory.name ? Validators.required(ctrl) : null, nonNullable: true }
		);
		this.newBuildingCompleteConstructionFormControl = new FormControl(
			this.guarantee.newBuildingCompleteConstruction,
			{ nonNullable: true }
		);
		this.extensionExistingBuildingFormControl = new FormControl(
			this.guarantee.extensionExistingBuilding,
			{ nonNullable: true }
		);
		this.retrofittingRepairExistingBuildingFormControl = new FormControl(
			this.guarantee.retrofittingRepairExistingBuilding,
			{ nonNullable: true }
		);
		if (!this.guarantee.extensionExistingBuilding && !this.guarantee.retrofittingRepairExistingBuilding) {
			this.newBuildingCompleteConstructionFormControl.setValue(true);
			this.guarantee.newBuildingCompleteConstruction = true;
		}
		if (this.guarantee.extensionExistingBuilding) {
			this.selectedOption.setValue('extensionExistingBuilding');
			this.extensionExistingBuildingFormControl.setValue(true);
			this.guarantee.newBuildingCompleteConstruction = false;
			this.guarantee.retrofittingRepairExistingBuilding = false;
		} else if (this.guarantee.retrofittingRepairExistingBuilding) {
			this.selectedOption.setValue('retrofittingRepairExistingBuilding');
			this.retrofittingRepairExistingBuildingFormControl.setValue(true);
			this.guarantee.newBuildingCompleteConstruction = false;
			this.guarantee.extensionExistingBuilding = false;
		} else {
			this.selectedOption.setValue('newBuildingCompleteConstruction');
			this.newBuildingCompleteConstructionFormControl.setValue(true);
			this.guarantee.retrofittingRepairExistingBuilding = false;
			this.guarantee.extensionExistingBuilding = false;
		}
		this.reasonFormControl = new FormControl(
			this.guarantee.reason,
			{ nonNullable: true }
		);
		this.natureMaterialFormControl = new FormControl(
			this.guarantee.natureMaterial,
			{ nonNullable: true }
		);
		this.conditionMaterialFormControl = new FormControl(
			this.guarantee.conditionMaterial,
			{ nonNullable: true }
		);
		this.ageMaterialFormControl = new FormControl(
			this.guarantee.ageMaterial,
			{ nonNullable: true }
		);
		this.residentialUseFormControl = new FormControl(this.guarantee.residentialUse, { nonNullable: true });
		this.industrialFormControl = new FormControl(this.guarantee.industrial, { nonNullable: true });
		this.agriculturalFormControl = new FormControl(this.guarantee.agricultural, { nonNullable: true });
		this.otherADBFormControl = new FormControl(this.guarantee.otherADB, { nonNullable: true });
		this.otherADBSpecifyFormControl = new FormControl(this.guarantee.otherADBSpecify, { nonNullable: true });
		this.buildingsFormControl = new FormControl(
			this.guarantee.industrialBuilding
				? 'industrial'
				: this.guarantee.agriculturalBuilding
					? 'agricultural'
					: null
		);
		this.activityBuildingFormControl = new FormControl(this.guarantee.activityBuilding, { nonNullable: true });
		this.acitivityInsideBuildingFormControl = new FormControl(
			this.guarantee.acitivityInsideBuilding,
			{ nonNullable: true }
		);
		this.presenceofChemicalFormControl = new FormControl(this.guarantee.presenceofChemical, { nonNullable: true });
		this.natureContentFormControl = new FormControl(this.guarantee.natureContent, { nonNullable: true });
		this.presenceofFermentationFormControl = new FormControl(
			this.guarantee.presenceofFermentation,
			{ nonNullable: true }
		);
		this.natureContent2FormControl = new FormControl(this.guarantee.natureContent2, { nonNullable: true });
		this.gasVapourFormControl = new FormControl(this.guarantee.gasVapour, { nonNullable: true });
		this.gasvaporNatureContentFormControl = new FormControl(
			this.guarantee.gasvaporNatureContent,
			{ nonNullable: true }
		);
		this.buildingHeatedFormControl = new FormControl(this.guarantee.buildingHeated, { nonNullable: true });
		this.heatingTypeFormControl = new FormControl(this.guarantee.heatingType, { nonNullable: true });
		this.qiaExtractorFormControl = new FormControl(this.guarantee.qiaExtractor, { nonNullable: true });
		this.qiaChimneyFormControl = new FormControl(this.guarantee.qiaChimney, { nonNullable: true });
		this.qiaNaturalventilationFormControl = new FormControl(
			this.guarantee.qiaNaturalventilation,
			{ nonNullable: true }
		);
		this.qiaForcedventilationFormControl = new FormControl(
			this.guarantee.qiaForcedventilation,
			{ nonNullable: true }
		);
		this.otherEquipmentFormControl = new FormControl(this.guarantee.otherEquipment, { nonNullable: true });
		this.specifyOtherEquipmentFormControl = new FormControl(
			this.guarantee.specifyOtherEquipment,
			{ nonNullable: true }
		);
		this.qiacondriskbuildingFormControl = new FormControl(
			this.guarantee.qiacondriskbuilding,
			{ nonNullable: true }
		);
		this.activityAgriculturalBuildingFormControl = new FormControl(
			this.guarantee.activityAgriculturalBuilding,
			{ nonNullable: true }
		);
		this.ambienceBuildingFormControl = new FormControl(this.guarantee.ambienceBuilding, { nonNullable: true });

		this.storageFodderFormControl = new FormControl(this.guarantee.storageFodder, { nonNullable: true });
		this.storageFertilizerFormControl = new FormControl(this.guarantee.storageFertilizer, { nonNullable: true });
		this.breedingAnimalsFormControl = new FormControl(this.guarantee.breedingAnimals, { nonNullable: true });
		this.cattleFormControl = new FormControl(this.guarantee.cattle, { nonNullable: true });
		this.pigsFormControl = new FormControl(this.guarantee.pigs, { nonNullable: true });
		this.polutryFormControl = new FormControl(this.guarantee.polutry, { nonNullable: true });
		this.otherAnimalsFormControl = new FormControl(this.guarantee.otherAnimals, { nonNullable: true });
		this.animalsInsideBuildingFormControl = new FormControl(
			this.guarantee.animalsInsideBuilding,
			{ nonNullable: true }
		);
		this.densityofAnimalsFormControl = new FormControl(this.guarantee.densityofAnimals, { nonNullable: true });
		this.animalsinShedFormControl = new FormControl(this.guarantee.animalsinShed, { nonNullable: true });
		this.manureManagementFormControl = new FormControl(
			this.guarantee.manureManagementOrganic,
			{ nonNullable: true }
		);
		this.manureManagementConcreteGratingDuckboardFormControl = new FormControl(
			this.guarantee.concreteGratingDuckboard,
			{ nonNullable: true }
		);
		this.manureManagementNoDuckboardFormControl = new FormControl(
			this.guarantee.noDuckboard,
			{ nonNullable: true }
		);
		this.naturalVentilationFormControl = new FormControl(
			this.guarantee.naturalVentilationWall,
			{ nonNullable: true }
		);
		this.naturalVentilationRoofFormControl = new FormControl(
			this.guarantee.naturalVentilationRoof,
			{ nonNullable: true }
		);
		this.forcedVentilationFormControl = new FormControl(this.guarantee.forcedVentilation, { nonNullable: true });
		this.otherVentilationFormControl = new FormControl(this.guarantee.otherVentilation, { nonNullable: true });
		this.otherVentilationSpecifyFormControl = new FormControl(
			this.guarantee.otherVentilationSpecify,
			{ nonNullable: true }
		);
		this.airRenewalFormControl = new FormControl(this.guarantee.airRenewal, { nonNullable: true });
		this.ammoniaFormControl = new FormControl(this.guarantee.ammonia, { nonNullable: true });
		this.hydrogenSulphideFormControl = new FormControl(this.guarantee.hydrogenSulphide, { nonNullable: true });
		this.humidityFormControl = new FormControl(this.guarantee.humidity, { nonNullable: true });
		this.buildingHumidityRateFormControl = new FormControl(
			this.guarantee.buildingHumidityRate,
			{ nonNullable: true }
		);
		this.soldToSub = this.userService.getSoldTosTransac('PGNTE')
			.pipe(

				switchMap(businessIds => {
					if (businessIds.length === 0) {
						return of(undefined);
					}

					return this.userService.getBocs(
						['name', 'businessId'],
						businessIds.map(x => `businessId:${ x }`).join(' OR ')
					);
				})
			).subscribe({
				next: soldToList => {
					this.soldTos = soldToList?.results;
					if (this.soldTos && this.soldTos.length !== 0 && !this.guarantee.soldTo) {
						this.guarantee.soldTo = this.soldTos[0].businessId;
						this.soldToFormControl.setValue(this.guarantee.soldTo);
					}
				},
				complete: () => {
					this.isLoading = false;
				}

			});
	}

	goBack() {
		if (this.guarantee.id !== undefined) {
			this.locationService.go(-1);
		} else {
			this.locationService.go(-1, '../guarantee-requests/new/guarantee-type-selector');
		}
	}

	onErrorForm(elem: ElementRef, onError: keyof ErrorObject, event: Event) {
		(<HTMLElement> elem.nativeElement).scrollIntoView();
		this.onErrorMandatory[onError] = true;
		event.preventDefault();
	}

	isSoldToValid(event: Event) {
		if (this.guarantee.soldTo === '') {
			this.onErrorForm(this.soldToDiv, 'soldTo', event);
			this.soldToFormControl.markAsTouched();
			this.soldToFormControl.updateValueAndValidity();
			return false;
		}
		return true;
	}

	isNameValid(event: Event) {
		const trimmedName = this.guarantee.name.trim();
		if (trimmedName === '') {
			this.guarantee.name = '';
			this.projectNameFormControl.setValue('', { emitEvent: false });
			this.onErrorForm(this.nameDiv, 'name', event);
			this.projectNameFormControl.markAsTouched();
			this.projectNameFormControl.setErrors({ required: true });
			this.projectNameFormControl.updateValueAndValidity();
			return false;
		}
		this.guarantee.name = trimmedName;
		this.projectNameFormControl.setValue(trimmedName, { emitEvent: false });
		return true;
	}

	async isNameUnique(): Promise<boolean> {
		this.isLoading = true;
		try {
			return await this.guaranteeService.checkNameUniquenessOrFeedback(this.guarantee.name);
		} finally {
			this.isLoading = false;
		}
	}

	async goToNextStep(event: Event) {
		this.resetOnError();
		// check mandatory fields
		// we can't push if any mandatory are not filled

		if (!this.isNameValid(event) || !this.isSoldToValid(event) || await this.isNameUnique()) {
			return;
		}

		await this.router.navigate([
			this.guarantee.id !== undefined
				? `/guarantee-requests/edit/${ this.guarantee.id }/project-environment`
				: '/guarantee-requests/new/project-environment'
		], { replaceUrl: true });
	}

	async saveGuarantee(event: Event) {
		event.preventDefault();
		this.resetOnError();
		if (!this.isNameValid(event) || !this.isSoldToValid(event)) {
			return;
		}
		const now = moment().toISOString();
		const userName = `${ this.user.firstname } ${ this.user.lastname }`;
		const userId = this.user.id;
		if (this.guarantee.status !== GuaranteeStatus.DRAFT) {
			this.guarantee.requestDate = now;
		}
		this.guarantee.requesterName = userName;
		this.guarantee.requesterId = userId;

		this.submitting = true;
		try {
			await this.guaranteeService.saveGuarantee(this.guarantee);
		} catch (err: unknown) {
			console.error(err);
			this.guarantee.status = GuaranteeStatus.DRAFT;
			this.snackBar.openFromComponent(
				SnackbarSaveDraftGuaranteeComponent,
				{
					duration: 5000,
					panelClass: ['copo-claim-draft-snackbar'],
					data: true
				}
			);
			return;
		} finally {
			this.submitting = false;
		}
		if (this.guarantee.status === GuaranteeStatus.DRAFT) {
			await this.router.navigate(['/guarantee-requests/drafts'], { replaceUrl: true });
			this.snackBar.openFromComponent(
				SnackbarSaveDraftGuaranteeComponent,
				{
					duration: 5000,
					panelClass: ['copo-claim-draft-snackbar']
				}
			);
		}
	}

	resetOnError() {
		this.onErrorMandatory.soldTo = false;
		this.onErrorMandatory.name = false;
	}

	soldToChanged(event: MatSelectChange) {
		this.guarantee.soldTo = <string> event.value;
		this.errorService.resetErrorMsg();
	}

	projectNameChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.name = target.value.trim();
		this.projectNameFormControl.setValue(this.guarantee.name, { emitEvent: false });
		this.errorService.resetErrorMsg();
	}

	radioSelectionChanged(selectedValue: string) {
		if (selectedValue === 'extensionExistingBuilding') {
			this.guarantee.extensionExistingBuilding = true;
			this.guarantee.newBuildingCompleteConstruction = false;
			this.guarantee.retrofittingRepairExistingBuilding = false;
			this.extensionExistingBuildingFormControl.setValue(true);
		} else if (selectedValue === 'retrofittingRepairExistingBuilding') {
			this.guarantee.retrofittingRepairExistingBuilding = true;
			this.guarantee.newBuildingCompleteConstruction = false;
			this.guarantee.extensionExistingBuilding = false;
			this.retrofittingRepairExistingBuildingFormControl.setValue(true);
		} else {
			this.guarantee.newBuildingCompleteConstruction = true;
			this.guarantee.retrofittingRepairExistingBuilding = false;
			this.guarantee.extensionExistingBuilding = false;
			this.newBuildingCompleteConstructionFormControl.setValue(true);
		}
		if (selectedValue !== 'retrofittingRepairExistingBuilding') {
			this.reasonFormControl.reset('');
			this.natureMaterialFormControl.reset('');
			this.conditionMaterialFormControl.reset('');
			this.ageMaterialFormControl.reset('');
			this.guarantee.reason = '';
			this.guarantee.natureMaterial = '';
			this.guarantee.conditionMaterial = '';
			this.guarantee.ageMaterial = '';
		}
	}

	reasonChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.reason = target.value;
	}

	natureMaterialChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.natureMaterial = target.value;
	}

	conditionMaterialChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.conditionMaterial = target.value;
	}

	ageMaterialChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.ageMaterial = target.value;
	}

	residentialUseChanged(checked: boolean) {
		this.guarantee.residentialUse = checked;
		if (!checked) {
			this.otherADBSpecifyFormControl.reset('');
			this.guarantee.otherADBSpecify = '';
		}
	}

	industrialChanged(checked: boolean) {
		this.guarantee.industrial = checked;
		if (!checked) {
			this.otherADBSpecifyFormControl.reset('');
			this.guarantee.otherADBSpecify = '';
		}
	}

	agriculturalChanged(checked: boolean) {
		this.guarantee.agricultural = checked;
		if (!checked) {
			this.otherADBSpecifyFormControl.reset('');
			this.guarantee.otherADBSpecify = '';
		}
	}

	otherADBChanged(checked: boolean) {
		this.guarantee.otherADB = checked;
		if (!checked) {
			this.otherADBSpecifyFormControl.reset('');
			this.guarantee.otherADBSpecify = '';
		}
	}

	otherADBSpecifyChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.otherADBSpecify = target.value;
	}

	buildingsChanged(event: MatRadioChange | Event) {
		if (!(event instanceof MatRadioChange) || event.source.name !== 'building') {
			return;
		}
		this.guarantee.industrialBuilding = event.value === 'industrial';
		this.guarantee.agriculturalBuilding = event.value === 'agricultural';
		this.buildingReset(<BuildingType> event.value);
	}

	buildingReset(buildingType: BuildingType) {
		if (buildingType !== 'industrial') {
			this.industrialBuildingReset();
		}
		if (buildingType !== 'agricultural') {
			this.agriculturalBuildingReset();
		}
	}

	activityChanged(checked: boolean) {
		if (!checked) {
			this.acitivityInsideBuildingFormControl.reset('');
			this.guarantee.acitivityInsideBuilding = '';
		}
	}

	activityAgriculturalChanged(checked: boolean) {
		if (!checked) {
			this.storageFodderFormControl.reset(false);
			this.storageFertilizerFormControl.reset(false);
			this.breedingAnimalsFormControl.reset(false);
			this.cattleFormControl.reset(false);
			this.pigsFormControl.reset(false);
			this.polutryFormControl.reset(false);
			this.otherAnimalsFormControl.reset(false);
			this.animalsInsideBuildingFormControl.reset('');
			this.animalsinShedFormControl.reset('');
			this.densityofAnimalsFormControl.reset('');
			this.guarantee.storageFodder = false;
			this.guarantee.storageFertilizer = false;
			this.guarantee.cattle = false;
			this.guarantee.pigs = false;
			this.guarantee.polutry = false;
			this.guarantee.breedingAnimals = false;
			this.guarantee.otherAnimals = false;
			this.guarantee.animalsInsideBuilding = '';
			this.guarantee.animalsinShed = '';
			this.guarantee.densityofAnimals = '';
		}
	}

	ambienceChanged(checked: boolean) {
		if (!checked) {
			this.buildingHumidityRateFormControl.reset('');
			this.guarantee.buildingHumidityRate = '';
			this.humidityFormControl.reset('');
			this.guarantee.humidity = '';
			this.qiacondriskbuildingFormControl.reset('');
			this.guarantee.qiacondriskbuilding = '';
		}
	}

	acitivityInsideBuildingChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.acitivityInsideBuilding = target.value;
	}

	presenceofChemicalChanged(event: MatRadioChange) {
		this.guarantee.presenceofChemical = String(event.value);
		if (event.value === 'false' || event.value === '' || event.value === 'true') {
			this.natureContentFormControl.reset('');
			this.guarantee.natureContent = '';
		}
	}

	natureContentChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.natureContent = target.value;
	}

	presenceofFermentationChanged(event: MatRadioChange) {
		this.guarantee.presenceofFermentation = String(event.value);
		if (event.value === 'false' || event.value === 'true' || event.value === '') {
			this.natureContent2FormControl.reset('');
			this.guarantee.natureContent2 = '';
		}
	}

	natureContent2Changed(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.natureContent2 = target.value;
	}

	gasVapourChanged(event: MatRadioChange) {
		this.guarantee.gasVapour = String(event.value);
		if (event.value === 'false' || event.value === 'true' || event.value === '') {
			this.gasvaporNatureContentFormControl.reset('');
			this.guarantee.gasvaporNatureContent = '';
		}
	}

	gasvaporNatureContentChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.gasvaporNatureContent = target.value;
	}

	buildingHeatedChanged(event: MatRadioChange) {
		this.guarantee.buildingHeated = String(event.value);
		if (event.value === 'false' || event.value === 'true' || event.value === 'NA') {
			this.heatingTypeFormControl.reset('');
			this.guarantee.heatingType = '';
		}
	}

	heatingTypeChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.heatingType = target.value;
	}

	qiaExtractorChanged(checked: boolean) {
		this.guarantee.qiaExtractor = checked;
	}

	qiaChimneyChanged(checked: boolean) {
		this.guarantee.qiaChimney = checked;
	}

	qiaNaturalventilationChanged(checked: boolean) {
		this.guarantee.qiaNaturalventilation = checked;
	}

	qiaForcedventilationChanged(checked: boolean) {
		this.guarantee.qiaForcedventilation = checked;
	}

	otherEquipmentChanged(checked: boolean) {
		this.guarantee.otherEquipment = checked;
		if (!checked) {
			this.specifyOtherEquipmentFormControl.reset('');
			this.guarantee.specifyOtherEquipment = '';
		}
	}

	qiacondriskbuildingChanged(event: MatRadioChange) {
		this.guarantee.qiacondriskbuilding = String(event.value);
	}

	specifyOtherEquipmentChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.specifyOtherEquipment = target.value;
	}

	storageFodderChanged(checked: boolean) {
		this.guarantee.storageFodder = checked;
	}

	storageFertilizerChanged(checked: boolean) {
		this.guarantee.storageFertilizer = checked;
	}

	breedingAnimalsChanged(checked: boolean) {
		this.guarantee.breedingAnimals = checked;
		if (!checked) {
			this.cattleFormControl.reset(false);
			this.pigsFormControl.reset(false);
			this.polutryFormControl.reset(false);
			this.otherAnimalsFormControl.reset(false);
			this.animalsInsideBuildingFormControl.reset('');
			this.animalsinShedFormControl.reset('');
			this.densityofAnimalsFormControl.reset('');
			this.manureManagementFormControl.reset(false);
			this.manureManagementConcreteGratingDuckboardFormControl.reset(false);
			this.manureManagementNoDuckboardFormControl.reset(false);
			this.guarantee.cattle = false;
			this.guarantee.pigs = false;
			this.guarantee.polutry = false;
			this.guarantee.otherAnimals = false;
			this.guarantee.animalsInsideBuilding = '';
			this.guarantee.animalsinShed = '';
			this.guarantee.densityofAnimals = '';
			this.guarantee.concreteGratingDuckboard = false;
			this.guarantee.noDuckboard = false;
		}
	}

	cattleChanged(checked: boolean) {
		this.guarantee.cattle = checked;
	}

	pigsChanged(checked: boolean) {
		this.guarantee.pigs = checked;
	}

	manureManagementChanged(checked: boolean) {
		if (!checked) {
			this.manureManagementConcreteGratingDuckboardFormControl.reset(false);
			this.manureManagementNoDuckboardFormControl.reset(false);
			this.guarantee.concreteGratingDuckboard = false;
			this.guarantee.noDuckboard = false;
		}
	}

	polutryChanged(checked: boolean) {
		this.guarantee.polutry = checked;
	}

	otherAnimalsChanged(checked: boolean) {
		this.guarantee.otherAnimals = checked;
		if (!checked) {
			this.animalsInsideBuildingFormControl.reset('');
			this.guarantee.animalsInsideBuilding = '';
		}
	}

	animalsInsideBuildingChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.animalsInsideBuilding = target.value;
	}

	densityofAnimalsChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.densityofAnimals = target.value;
	}

	animalsinShedChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.animalsinShed = target.value;
	}

	manureManagementConcreteGratingDuckboardChanged(checked: boolean) {
		this.guarantee.concreteGratingDuckboard = checked;
	}

	manureManagementNoDuckboardChanged(checked: boolean) {
		this.guarantee.noDuckboard = checked;
	}

	naturalVentilationChanged(checked: boolean) {
		this.guarantee.naturalVentilationWall = checked;
	}

	naturalVentilationRoofChanged(checked: boolean) {
		this.guarantee.naturalVentilationRoof = checked;
	}

	forcedVentilationChanged(checked: boolean) {
		this.guarantee.forcedVentilation = checked;
	}

	otherVentilationChanged(checked: boolean) {
		this.guarantee.otherVentilation = checked;
		if (!checked) {
			this.otherVentilationSpecifyFormControl.reset('');
			this.guarantee.otherVentilationSpecify = '';
		}
	}

	otherVentilationSpecifyChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.otherVentilationSpecify = target.value;
	}

	airRenewalChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.airRenewal = target.value;
	}

	ammoniaChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.ammonia = target.value;
	}

	hydrogenSulphideChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.hydrogenSulphide = target.value;
	}

	humidityChanged(event: Event) {
		const target = <HTMLInputElement> event.target;
		this.guarantee.humidity = target.value;
	}

	buildingHumidityRateChanged(event: MatRadioChange) {
		this.guarantee.buildingHumidityRate = String(event.value);
	}

	industrialBuildingReset() {
		this.activityBuildingFormControl.reset(false);
		this.acitivityInsideBuildingFormControl.reset('');
		this.presenceofChemicalFormControl.reset('');
		this.natureContentFormControl.reset('');
		this.presenceofFermentationFormControl.reset('');
		this.natureContent2FormControl.reset('');
		this.gasVapourFormControl.reset('');
		this.gasvaporNatureContentFormControl.reset('');
		this.buildingHeatedFormControl.reset('');
		this.heatingTypeFormControl.reset('');
		this.qiaExtractorFormControl.reset(false);
		this.qiaChimneyFormControl.reset(false);
		this.qiaNaturalventilationFormControl.reset(false);
		this.qiaForcedventilationFormControl.reset(false);
		this.otherEquipmentFormControl.reset(false);
		this.specifyOtherEquipmentFormControl.reset('');
		this.qiacondriskbuildingFormControl.reset('');
		this.buildingHumidityRateFormControl.reset('');
		this.guarantee.industrialBuilding = false;
		this.guarantee.acitivityInsideBuilding = '';
		this.guarantee.presenceofChemical = '';
		this.guarantee.natureContent = '';
		this.guarantee.presenceofFermentation = '';
		this.guarantee.natureContent2 = '';
		this.guarantee.gasVapour = '';
		this.guarantee.gasvaporNatureContent = '';
		this.guarantee.buildingHeated = '';
		this.guarantee.heatingType = '';
		this.guarantee.qiaExtractor = false;
		this.guarantee.qiaChimney = false;
		this.guarantee.qiaNaturalventilation = false;
		this.guarantee.qiaForcedventilation = false;
		this.guarantee.otherEquipment = false;
		this.guarantee.specifyOtherEquipment = '';
		this.guarantee.qiacondriskbuilding = '';
		this.guarantee.buildingHumidityRate = '';
	}

	agriculturalBuildingReset() {
		this.activityAgriculturalBuildingFormControl.reset(false);
		this.storageFodderFormControl.reset(false);
		this.storageFertilizerFormControl.reset(false);
		this.breedingAnimalsFormControl.reset(false);
		this.cattleFormControl.reset(false);
		this.pigsFormControl.reset(false);
		this.polutryFormControl.reset(false);
		this.otherAnimalsFormControl.reset(false);
		this.animalsInsideBuildingFormControl.reset('');
		this.animalsinShedFormControl.reset('');
		this.densityofAnimalsFormControl.reset('');
		this.manureManagementFormControl.reset(false);
		this.manureManagementConcreteGratingDuckboardFormControl.reset(false);
		this.manureManagementNoDuckboardFormControl.reset(false);
		this.ambienceBuildingFormControl.reset(false);
		this.naturalVentilationFormControl.reset(false);
		this.naturalVentilationRoofFormControl.reset(false);
		this.forcedVentilationFormControl.reset(false);
		this.otherVentilationFormControl.reset(false);
		this.otherVentilationSpecifyFormControl.reset('');
		this.airRenewalFormControl.reset('');
		this.ammoniaFormControl.reset('');
		this.hydrogenSulphideFormControl.reset('');
		this.humidityFormControl.reset('');
		this.qiacondriskbuildingFormControl.reset('');
		this.buildingHumidityRateFormControl.reset('');
		this.guarantee.agriculturalBuilding = false;
		this.guarantee.storageFodder = false;
		this.guarantee.storageFertilizer = false;
		this.guarantee.breedingAnimals = false;
		this.guarantee.cattle = false;
		this.guarantee.pigs = false;
		this.guarantee.polutry = false;
		this.guarantee.otherAnimals = false;
		this.guarantee.animalsInsideBuilding = '';
		this.guarantee.animalsinShed = '';
		this.guarantee.densityofAnimals = '';
		this.guarantee.concreteGratingDuckboard = false;
		this.guarantee.noDuckboard = false;
		this.guarantee.naturalVentilationWall = false;
		this.guarantee.naturalVentilationRoof = false;
		this.guarantee.forcedVentilation = false;
		this.guarantee.otherVentilation = false;
		this.guarantee.otherVentilationSpecify = '';
		this.guarantee.airRenewal = '';
		this.guarantee.ammonia = '';
		this.guarantee.hydrogenSulphide = '';
		this.guarantee.humidity = '';
		this.guarantee.qiacondriskbuilding = '';
		this.guarantee.buildingHumidityRate = '';
	}

	ngOnDestroy() {
		this.soldToSub.unsubscribe();
	}
}
